// extracted by mini-css-extract-plugin
export default {"mg20":"styles_mg20__nTof+","label":"styles_label__Jz7N0","input":"styles_input__qGKif"};